export default __webpack_public_path__ + "static/media/Noe Text Bold.02133634.otf";